<template>

     <div class="flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
   
        <img style="height: 98%;  width: 60%; position: absolute;" src="../../assets/arte-maes_unidas.png" />
        <div class="text-center align">
            <h4> Prezada,  {{usuario.nome}}!</h4>    
        </div>
        <div class="text-center align-texto">
            Gostaríamos de salientar que, para utilizar todos os recursos disponíveis neste Projeto, você deve fazer o <i>download</i> do aplicativo Mães do Brasil na loja do Google Play (versão Android) ou da Apple Store (versão iOS).
            <p style="padding: 4rem !important;">
              <b-button size="lg" @click="telaInicial" variant="primary"> OK, entendi</b-button>        
            </p>   
      </div>
  
      </b-row>
    </div>
  </div>
 

</template>

<script>
import Vue from 'vue'
import SessionStorage from '@/services/session-storage'


export default {
  name: 'Aviso App',
  components: {
    
  },
  data () {
    return {        
    }
  },
  created () {
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
  },
  mounted() {
  //    console.log(SessionStorage.get('permissoes'));
  },
  computed: {
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    }
  },
  methods: {
    telaInicial(){
        this.$router.push({path: '/'})
        return true
    }
  }
}
</script>

<style>

  .bg {
    /* The image used */
    background-image: url("../../assets/arte-maes_unidas.png");

    /* Full height */
    height: 100%;
    width: 100%;
    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;  
    background-color: #ebe1e2; 
  }

  .align {
  position: absolute; 
  top: 48%;
  }

  .align-texto {
    font-size: 18px;
    position: absolute; 
    top: 58%;
    margin-left: 25%;
    margin-right: 25%;
  }
</style>


// WEBPACK FOOTER //
// src/pages/auth/AvisoAppLogin.vue